import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65d9c05b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "result-info" }
const _hoisted_4 = { class: "trailer-name-container" }
const _hoisted_5 = {
  key: 0,
  class: "trailer-fault-dot"
}
const _hoisted_6 = { class: "location-info" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "title-case timestamp" }
const _hoisted_9 = {
  key: 0,
  class: "reservation-expiry"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["nearby-result-card", _ctx.selectedClass])
    }, [
      _createElementVNode("div", {
        class: "result-icon",
        innerHTML: _ctx.icon
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["location-name title-case", { 'mark-green': _ctx.isReserved }])
          }, _toDisplayString(_ctx.name), 3),
          (_ctx.hasAnyFault === true)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: _normalizeClass(["fault-circle", {
                                orange: _ctx.hasDotExpired,
                                red: _ctx.hasCargoSensorError,
                            }])
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.validTrailerType === true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.trailerTypeText) + " • ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.lastUpdated), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["location-info", { 'is-reserved': _ctx.isReserved }])
        }, [
          (_ctx.isReserved)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                _createTextVNode(" Expires "),
                _createElementVNode("strong", null, _toDisplayString(_ctx.reservationEndTime), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.timeZone), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], 2)
  ]))
}